import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'frontend-time-input-24hs',
  templateUrl: './time-input-24hs.component.html',
  styleUrls: ['./time-input-24hs.component.scss'],
  standalone: false
})
export class TimeInput24hsComponent {
  @Input() form: FormGroup;
}
